import { MerchCardColumns } from 'pricing-pages-ui-components/components/MerchCardColumns';
import { jsx as _jsx } from "react/jsx-runtime";
const MobileCardWrapper = ({
  children,
  hasBadge
}) => {
  return /*#__PURE__*/_jsx(MerchCardColumns, {
    columns: 1,
    maxInlineSize: "initial",
    marginBlockStart: hasBadge ? '1100' : '500',
    hasBadgeOnFirstColumn: hasBadge,
    hasBadgeOnLastColumn: hasBadge,
    children: children
  });
};
export default MobileCardWrapper;